import { CarregandoBloco, CarregandoCards, CarregandoTabela } from "@/components/carregando";

/**
 * Carregamento com cards dos Disparos em massa (25/10/2026): o formato do
 * painel (4 cards de número, os 3 quadros do meio e a tabela de campanhas)
 * piscando até os dados chegarem — SMS, Ligação e WhatsApp usam o mesmo.
 */
export function PainelCarregando() {
  return (
    <div className="space-y-5" data-e2e="disparos-carregando">
      <CarregandoCards quantos={4} className="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-4 gap-4" altura="h-[140px]" />
      <div className="grid grid-cols-1 lg:grid-cols-3 gap-5">
        <CarregandoBloco altura="h-[238px]" />
        <CarregandoBloco altura="h-[238px]" />
        <CarregandoBloco altura="h-[238px]" />
      </div>
      <CarregandoTabela linhas={4} colunas={6} />
    </div>
  );
}

/** Relatório de uma campanha: funil em cards, os números do retorno e a lista. */
export function RelatorioCarregando() {
  return (
    <div className="space-y-5" data-e2e="disparos-relatorio-carregando">
      <CarregandoBloco altura="h-20" />
      <CarregandoCards quantos={4} />
      <CarregandoBloco altura="h-56" />
      <CarregandoTabela linhas={5} colunas={4} />
    </div>
  );
}
